import React from 'react';
import type { ServiceMutationType } from 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
import 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
type UpdateInfo =
  | {
      itemsNumber: number;
      message: string;
    }
  | null
  | undefined;
export type ServicesContextType = {
  attendeesList: ReadonlyArray<
    Readonly<{
      birthdate?: string;
      firstName?: string;
      id: string;
      isChild?: boolean;
      lastName?: string;
      unicodeFirstName?: string;
      unicodeLastName?: string;
    }>
  >;
  availableActivities?: ReadonlyArray<UpsellActivity>;
  currency?: string;
  dates?: {
    arrivalDate: number;
    departureDate: number;
  };
  hasRentals?: boolean;
  hideAgeServiceSlot?: boolean;
  isPriceForAdultOnly?: boolean;
  onlyBookableServices?: boolean;
  scheduleReservationMessage?: string;
  setUpdateInfo?: (arg0: UpdateInfo) => void;
  showRentAllSchedules?: boolean;
  trackingData?: Readonly<{
    actionGA: string;
    categoryGA: string;
  }>;
  updateInfo?: UpdateInfo;
  updateService: (
    service: ServiceMutationType,
    pricingInfo: PricingInfoWithScheduleType,
    serviceIds: ReadonlyArray<string>,
    attendeeIds: ReadonlyArray<string>,
    upsellType?: string,
  ) => Promise<any>;
};
// @ts-expect-error
export const ServicesContext = React.createContext<ServicesContextType>({});
